export default __webpack_public_path__ + "static/media/dashboard_inactive.796642c7.svg";